export const WRAPPER_TYPES = {
  default: 'default',
  scroll: 'scroll',
};

export const STATUSES = {
  win: 'win',
  lose: 'lose',
};

export const PER_PAGE = 25;

export const OFFSET_Y = 200;
